import { HTMLStyledProps, styled } from 'styled-system/jsx';

type TokenIconProps = HTMLStyledProps<'img'> & {
  src: string;
  alt: string;
};

export const TokenIcon: React.FC<TokenIconProps> = ({ src, alt, ...props }) => {
  return <styled.img src={src} alt={alt} w="24px" h="24px" {...props} />;
};
